import { Trophy, CalendarDays } from "lucide-react";

export function WeeklyChallenge({ weekly, members }) {
  if (!weekly) return null;
  const pct = Math.min(100, Math.round((weekly.done / weekly.target) * 100));
  const won = weekly.done >= weekly.target;
  const contributors = members.filter((m) => m.week_lessons > 0);

  return (
    <section className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise rise-1" data-testid="team-weekly-challenge">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-500">
          <Trophy className="w-4 h-4 text-orange-500" /> Défi de la semaine
        </span>
        <span className="flex items-center gap-1 text-xs font-bold text-slate-500" data-testid="team-weekly-days-left">
          <CalendarDays className="w-4 h-4" /> {weekly.days_left} j restant{weekly.days_left > 1 ? "s" : ""}
        </span>
      </div>
      <p className="font-display text-2xl font-bold uppercase leading-tight">
        {weekly.target} leçons ensemble
      </p>
      <div className="h-6 rounded-full bg-slate-100 border border-slate-200 overflow-hidden relative">
        <div
          className={`h-full transition-[width] duration-700 ${won ? "bg-emerald-500" : "hazard-stripe"}`}
          style={{ width: `${pct}%` }}
          data-testid="team-weekly-bar"
        />
        <span className="absolute inset-0 grid place-items-center text-xs font-bold text-slate-900" data-testid="team-weekly-count">
          {weekly.done} / {weekly.target}
        </span>
      </div>
      {won && <p className="text-sm font-bold text-emerald-700" data-testid="team-weekly-won">Défi réussi, bravo l'équipe !</p>}
      {contributors.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="team-weekly-contributors">
          {contributors.map((m, i) => (
            <span key={`${m.name}-${i}`} className={`text-xs font-bold rounded-full px-3 py-1 ${m.is_me ? "bg-orange-100 text-orange-800" : "bg-slate-100 text-slate-700"}`}>
              {m.name} · {m.week_lessons}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
